import { render, staticRenderFns } from "./CobaRecaptha.vue?vue&type=template&id=700a2141&"
import script from "./CobaRecaptha.vue?vue&type=script&lang=js&"
export * from "./CobaRecaptha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports